/**
 * Danh sách các chứng từ chưa sinh hạch toán
 */
export default {
  All: 0,
  CaReceipt: 1, //31
  BuTransfer: 2, //34, 165
};
